var _style, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarDashboardLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150",
      fill: "white"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64,15.5H21.5c-3.3,0-6,2.7-6,6v62.4c0,3.3,2.7,6,6,6H64c3.3,0,6-2.7,6-6V21.5C70,18.2,67.3,15.5,64,15.5z  M65.5,79c0,3.5-2.7,6.4-6,6.4H25.9c-3.3,0-6-2.8-6-6.4V25.8c0-3.5,2.7-6.4,6-6.4h33.6c3.3,0,6,2.8,6,6.4V79z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M128.5,54H83.4c-3.3,0-6,2.7-6,6v68.5c0,3.3,2.7,6,6,6h45.1c3.3,0,6-2.7,6-6V60C134.5,56.7,131.8,54,128.5,54z  M130.9,124.9c0,3.3-2.7,6-6,6H87c-3.3,0-6-2.7-6-6V63.2c0-3.3,2.7-6,6-6h37.9c3.3,0,6,2.7,6,6V124.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64,97.3H21.5c-3.3,0-6,2.7-6,6v25.2c0,3.3,2.7,6,6,6H64c3.3,0,6-2.7,6-6v-25.2C70,100,67.3,97.3,64,97.3z M66.6,126.2 c0,3.3-2.7,6-6,6H24.8c-3.3,0-6-2.7-6-6v-20.6c0-3.3,2.7-6,6-6h35.8c3.3,0,6,2.7,6,6V126.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M128.5,15.6H83c-3.3,0-6,2.7-6,6v18.9c0,3.3,2.7,6,6,6h45.5c3.3,0,6-2.7,6-6V21.6C134.5,18.3,131.8,15.6,128.5,15.6z  M131.7,38.6c0,3.3-2.7,6-6,6H85.8c-3.3,0-6-2.7-6-6v-15c0-3.3,2.7-6,6-6h39.9c3.3,0,6,2.7,6,6L131.7,38.6L131.7,38.6z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.1,89.9h-42.5c-3.3,0-6-2.7-6-6V21.5c0-3.3,2.7-6,6-6h42.5c3.3,0,6,2.7,6,6v62.4 C217.1,87.2,214.4,89.9,211.1,89.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.7,134.5h-45.1c-3.3,0-6-2.7-6-6V60c0-3.3,2.7-6,6-6h45.1c3.3,0,6,2.7,6,6v68.5 C281.7,131.8,279,134.5,275.7,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.1,134.5h-42.5c-3.3,0-6-2.7-6-6v-25.2c0-3.3,2.7-6,6-6h42.5c3.3,0,6,2.7,6,6v25.2 C217.1,131.8,214.4,134.5,211.1,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.7,46.5h-45.5c-3.3,0-6-2.7-6-6V21.6c0-3.3,2.7-6,6-6h45.5c3.3,0,6,2.7,6,6v18.9 C281.7,43.9,279,46.5,275.7,46.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.5,9.1H185.9c-3.3,0-6,2.7-6,6v117.5c0,3.3,2.7,6,6,6h117.5c3.3,0,6-2.7,6-6V15.1C309.5,11.8,306.8,9.1,303.5,9.1z  M240,123.2c0,3.3-2.7,6-6,6h-38.7c-3.3,0-6-2.7-6-6v-22.6c0-3.3,2.7-6,6-6H234c3.3,0,6,2.7,6,6V123.2z M240,81.7c0,3.3-2.7,6-6,6 h-38.7c-3.3,0-6-2.7-6-6V24.5c0-3.3,2.7-6,6-6H234c3.3,0,6,2.7,6,6V81.7z M300,123.2c0,3.3-2.7,6-6,6h-41.1c-3.3,0-6-2.7-6-6V60.4 c0-3.3,2.7-6,6-6H294c3.3,0,6,2.7,6,6V123.2z M300,41.4c0,3.3-2.7,6-6,6h-41.5c-3.3,0-6-2.7-6-6V24.6c0-3.3,2.7-6,6-6H294 c3.3,0,6,2.7,6,6V41.4z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "128.4,76.6 75.1,23.1 21.5,76.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.6,73.3 109.6,126.8 85.2,126.8 85.2,95.5 64.8,95.5 64.8,126.8 39.7,126.8 39.7,73.3  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.8,10.2H16.2c-3.3,0-6,2.7-6,6v117.5c0,3.3,2.7,6,6,6h117.5c3.3,0,6-2.7,6-6V16.2C139.8,13,137.1,10.2,133.8,10.2z  M109.5,76.6v50.2H85.3V95.5H64.7v31.3h-25V76.6H21.6L75,23.2l53.4,53.4C128.4,76.6,109.5,76.6,109.5,76.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarDashboardLine);
export default __webpack_public_path__ + "static/media/SidebarDashboardLine.0057d78b5127186320c6a4534850c055.svg";
export { ForwardRef as ReactComponent };